export default __webpack_public_path__ + "static/media/icone-nuvem-selecionar.fea9080c.svg";